import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { resetDisabledRoute, setDisabledRoutes } from "../actions/disabledRoutes";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import IVenueSettings from "../interfaces/IVenueSettings";
import * as URLS from "../const/URL.const";
import { IReduxAppState } from "../reducers";
import { disableAllButDetails, disableEposNow } from "../utils/disableRoutes";
import { isDetailsFilled } from "../utils/objectCheck";
import { useSnackbarMessages } from "../yoello-lib/modules/components/snackbar/SnackbarContext";


/**Checks if the details have changed and disables the routes based on that */
export function useDetailsFilled() {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);

    const subscription = useSelector((state: IReduxAppState) => state.subscription);
    const venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData);
    const venueSettings = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueSettings);
    const venueLocation = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueLocation);
    const disabledRoutes = useSelector((state: IReduxAppState) => state.disabledRoutes);
    /**We want to override the set disabled fields if they've already been set */
    const hasDisabled = useRef(false);
    /**Reference of the last venue to receive snackbar */
    const messagedVenue = useRef("");
    const { pathname } = useLocation();

    const dispatch = useDispatch();
    const { sendSnackbarMessage } = useSnackbarMessages()!;
    const { t } = useTranslation();

    useEffect(() => {
        if (venue && venueSettings && venueLocation) {
            if (!isDetailsFilled(venue, venueSettings as IVenueSettings, venueLocation! as ILocationAPIObject)) {
                const newRoutes = disableAllButDetails();
                hasDisabled.current = true;
                if (messagedVenue.current !== selectedVenueId) {
                    messagedVenue.current = selectedVenueId;
                    if(pathname.includes(URLS.PROFILE_DETAILS_URL)){
                        sendSnackbarMessage(t("forms.details.error"), "error");
                    }
                }
                if (newRoutes.length !== disabledRoutes.length) {
                    dispatch(setDisabledRoutes(newRoutes));
                }
            } else if (subscription === "EPOSNOW") {
                dispatch(setDisabledRoutes(disableEposNow(), hasDisabled.current));
                hasDisabled.current = true;
            } else {
                if (disabledRoutes.length > 1) {
                    dispatch(resetDisabledRoute());
                }
            }
        }
        // eslint-disable-next-line
    }, [venue, venueSettings, venueLocation, subscription]);

    useEffect(() => {
        if (selectedVenueId
            && hasDisabled.current === true) {
            hasDisabled.current = false;
        }
    }, [selectedVenueId])
}